/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { FC, PropsWithChildren } from 'react';

import { configApiRef, useApi } from '@backstage/frontend-plugin-api';
import { Helmet } from 'react-helmet';

type Props = {
  title?: string;
};

/**
 * Sets the title in the html header
 *
 * @public
 *
 */
export const HtmlHeaderTitle: FC<PropsWithChildren<Props>> = ({
  children,
  title,
}) => {
  const configApi = useApi(configApiRef);
  const appTitle = configApi.getOptionalString('app.title') ?? 'Backstage';
  const titleTemplate = `${title} | %s | ${appTitle}`;
  const defaultTitle = `${title} | ${appTitle}`;

  return (
    <>
      <Helmet defaultTitle={defaultTitle} titleTemplate={titleTemplate} />
      {children}
    </>
  );
};
